import React from 'react'
import topper from'../Assets/Images/topper.jpg'
import topper4 from'../Assets/Images/topper4.jpg'
import topper2 from'../Assets/Images/topper2.jpg'
import like from'../Assets/Images/like.gif' 
import Slider from "react-slick";
const Toppers = () => {
  var settings = {
    autoplay: true,
    infinite: true,
    autoplaySpeed: 2000,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    initialSlide: 0,
    responsive: [
        {
          breakpoint: 1300,
          settings: {
            slidesToShow: 1,
            slidesToScroll:1,
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            slidesToScroll:2,
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            initialSlide: 1
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
  };
  return (
     <>
     <Slider {...settings}>
           <div>
                 <div className="acheiver-blk">
                     <div className="acheiver-image"> 
                         <img src={topper} alt="Sacred Heart Convent School, Jagraon"/>
                     </div>
                     <div className="content">
                         <h3>Student Name</h3>
                         <p>Stream</p>
                     </div> 
                     <div className="percentage">
                         98%
                     </div>
                     <img src={like} className="balon-gif" alt="Sacred Heart Convent School, Jagraon" /> 
                 </div>
            </div>
              <div>
                <div className="acheiver-blk">
                     <div className="acheiver-image"> 
                         <img src={topper4} alt="Sacred Heart Convent School, Jagraon"/>
                     </div>
                     <div className="content">
                         <h3>Student Name</h3>
                         <p>Stream</p>
                     </div> 
                     <div className="percentage">
                         98%
                     </div>
                     <img src={like} className="balon-gif" alt="Sacred Heart Convent School, Jagraon" /> 
                 </div>
              </div>
              <div>
                 <div className="acheiver-blk">
                     <div className="acheiver-image"> 
                         <img src={topper2} alt="Sacred Heart Convent School, Jagraon"/>
                     </div>
                     <div className="content">
                         <h3>Student Name</h3>
                         <p>Stream</p>
                     </div> 
                     <div className="percentage">
                         98%
                     </div>

                     <img src={like} className="balon-gif" alt="Sacred Heart Convent School, Jagraon" /> 
                 </div>
              </div>
    </Slider>
     </>
  )
}

export default Toppers
